import { createSlice } from "@reduxjs/toolkit";

import { getColorsList, addColorsList, updateColorsList, deleteColorsList } from "./thunk";

export const initialState = {
    colorsList: {
        content: []
    },
    errors: {}
};

const ColorsSlice = createSlice({
    name: 'Colors',
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder.addCase(getColorsList.fulfilled, (state: any, action: any) => {
            state.colorsList = action.payload;
        });
        builder.addCase(getColorsList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(addColorsList.fulfilled, (state: any, action: any) => {
            console.log(action.payload)
            state.colorsList.content.unshift(action.payload);
        });
        builder.addCase(addColorsList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(updateColorsList.fulfilled, (state: any, action: any) => {
            state.colorsList.content = state.colorsList.content.map((color: any) =>
                color.id === action.payload.id
                    ? { ...color, ...action.payload }
                    : color
            );
        });

        builder.addCase(updateColorsList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(deleteColorsList.fulfilled, (state: any, action: any) => {
            state.colorsList.content = state.colorsList.content.filter(
                (colorsList: any) => colorsList.id !== action.payload
            );
            console.log(action.payload)
        });
        builder.addCase(deleteColorsList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
    }
});

export default ColorsSlice.reducer;